export enum ColumnKey {
  StudentName = 'studentName',
  StudentKlass = 'studentKlass',
  BalanceBefore = 'balanceBefore',
  WriteOffs = 'writeOffs',
  PaymentsResult = 'paymentsResult',
  CorrectionPaymentsResult = 'correctionPaymentsResult',
  BalanceAfter = 'balanceAfter',
}

export const columnKeysLeft = [ColumnKey.StudentName]

export const columnKeysMain = [
  ColumnKey.StudentKlass,
  ColumnKey.BalanceBefore,
  ColumnKey.PaymentsResult,
  ColumnKey.CorrectionPaymentsResult,
  ColumnKey.WriteOffs,
  ColumnKey.BalanceAfter,
]

const headerCells = {
  [ColumnKey.StudentName]: 'ФИО',
  [ColumnKey.StudentKlass]: 'Класс',
  [ColumnKey.BalanceBefore]: 'Баланс\u00A0на\u00A0начало\u00A0периода',
  [ColumnKey.PaymentsResult]: 'Пополнения',
  [ColumnKey.CorrectionPaymentsResult]: 'Пополнения корректирующие',
  [ColumnKey.WriteOffs]: 'Списания',
  [ColumnKey.BalanceAfter]: 'Баланс\u00A0на\u00A0конец\u00A0периода',
}

export const getHeaderCells = (currency: string): Record<ColumnKey, string> => {
  return Object.fromEntries(
    Object.entries(headerCells).map(([key, value]) => {
      if (key === ColumnKey.StudentName || key === ColumnKey.StudentKlass) {
        return [key as ColumnKey, value]
      } else {
        return [key as ColumnKey, `${value},\u00A0${currency}`]
      }
    }),
  ) as Record<ColumnKey, string>
}

export const headerCellsProps = {
  [ColumnKey.StudentName]: {
    alignLeft: true,
    width: 200,
    bgFilled: true,
  },
  [ColumnKey.StudentKlass]: {
    alignCenter: true,
    borderRight: true,
    ignoreFirstChild: true,
    bgFilled: true,
  },
  [ColumnKey.BalanceBefore]: {
    alignRight: true,
    borderRight: true,
    bgFilled: true,
  },
  [ColumnKey.PaymentsResult]: {
    alignRight: true,
    borderRight: true,
    bgFilled: true,
  },
  [ColumnKey.CorrectionPaymentsResult]: {
    alignRight: true,
    borderRight: true,
    bgFilled: true,
  },
  [ColumnKey.WriteOffs]: {
    alignRight: true,
    borderRight: true,
    bgFilled: true,
  },
  [ColumnKey.BalanceAfter]: {
    alignRight: true,
    bgFilled: true,
  },
}

export const cellsProps = {
  [ColumnKey.StudentName]: { alignLeft: true, width: 200 },
  [ColumnKey.StudentKlass]: {
    alignCenter: true,
    borderRight: true,
    ignoreFirstChild: true,
  },
  [ColumnKey.BalanceBefore]: {
    alignRight: true,
    borderRight: true,
  },
  [ColumnKey.PaymentsResult]: { alignRight: true, borderRight: true },
  [ColumnKey.CorrectionPaymentsResult]: { alignRight: true, borderRight: true },
  [ColumnKey.WriteOffs]: { alignRight: true, borderRight: true },
  [ColumnKey.BalanceAfter]: { alignRight: true },
}

export const totalCellsProps = {
  [ColumnKey.StudentName]: {
    alignRight: true,
    width: 200,
    bold: true,
  },
  [ColumnKey.StudentKlass]: {
    alignCenter: true,
    highlighted: true,
    bold: true,
    ignoreFirstChild: true,
    borderRight: true,
  },
  [ColumnKey.BalanceBefore]: {
    alignRight: true,
    highlighted: true,
    bold: true,
    borderRight: true,
  },
  [ColumnKey.PaymentsResult]: {
    alignRight: true,
    highlighted: true,
    borderRight: true,
    bold: true,
  },
  [ColumnKey.CorrectionPaymentsResult]: {
    alignRight: true,
    highlighted: true,
    borderRight: true,
    bold: true,
  },
  [ColumnKey.WriteOffs]: {
    alignRight: true,
    highlighted: true,
    borderRight: true,
    bold: true,
  },
  [ColumnKey.BalanceAfter]: {
    alignRight: true,
    highlighted: true,
    bold: true,
  },
}
